module.exports = __webpack_public_path__ + "img/visa.280dba97.svg";